import { render, staticRenderFns } from "./IdColumnTable.vue?vue&type=template&id=53c29c0a&scoped=true&"
import script from "./IdColumnTable.vue?vue&type=script&lang=js&"
export * from "./IdColumnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c29c0a",
  null
  
)

export default component.exports